module.exports = __webpack_public_path__ + "img/card-contract-corporation.dcf5f57d.svg";